import { render, staticRenderFns } from "./VuesticProfileCard.vue?vue&type=template&id=606f2b9a"
import script from "./VuesticProfileCard.vue?vue&type=script&lang=js"
export * from "./VuesticProfileCard.vue?vue&type=script&lang=js"
import style0 from "./VuesticProfileCard.vue?vue&type=style&index=0&id=606f2b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports